/** @format */
import {
    ProductConditionValue,
    ProductState,
    ProductSummaryV2,
} from '@toucan/client/global/product';

export const nullProductSummary: ProductSummaryV2 = {
    id: 0,
    modelId: 0,
    sku: '',
    fullSku: '',
    modelName: '',
    name: '',
    discountIsPercentage: false,
    description: '',
    conditionDescription: '',
    listPrice: '',
    productPriceOriginal: '',
    value: 0,
    internalImages: [],
    condition: ProductConditionValue.NEW,
    priceModifiers: [],
    hasCustomDescription: false,
    images: [],
    attributes: [],
    discount: '',
    state: ProductState.OFFLINE,
    primaryCategoryName: '',
    observations: [],
    customDescription: '',
};
